import React from "react"
import { ReactSVG } from "react-svg"
import logo from "@images/black-impressit-logo.svg"
import acceptIcon from "@images/black-filter-accept-icon.svg"
import { useFilterOptions } from "../../hooks"
import {
  StyledBlogFilterContainer,
} from "../../styled"
import {
  StyledMobileAndDesktopFilterMenuWrapper,
  StyledFilterHeader,
  StyledFilterHeaderConfirmButton,
  StyledFilterTitle,
  StyledCategoryTitle,
  StyledMobileFilterContainer,
} from "./styled"

const MobileFilterMenu = () => {
  const { filterOptions, closeMobileFilters } = useFilterOptions();
  
  return (
    <StyledMobileAndDesktopFilterMenuWrapper>
      <StyledFilterHeader>
        <ReactSVG src={logo} />
        <StyledFilterHeaderConfirmButton onClick={closeMobileFilters}>
          <ReactSVG src={acceptIcon} />
        </StyledFilterHeaderConfirmButton>
      </StyledFilterHeader>
      <StyledMobileFilterContainer>
        <StyledFilterTitle>Blog</StyledFilterTitle>
        <StyledCategoryTitle>Category</StyledCategoryTitle>
        <StyledBlogFilterContainer>
          {filterOptions}
        </StyledBlogFilterContainer>
      </StyledMobileFilterContainer>
    </StyledMobileAndDesktopFilterMenuWrapper>
  )
}

export default MobileFilterMenu
